var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-mute',
                        view: publicPath + 'sprite.svg#view-icon-mute',
                        viewBox: '0 0 448.075 448.075',
                        title: 'icons/fonctions/mute',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };